import { render, staticRenderFns } from "./AccountSelectorItem.vue?vue&type=template&id=24c91d72"
import script from "./AccountSelectorItem.vue?vue&type=script&lang=js"
export * from "./AccountSelectorItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports